import { createAction } from '@reduxjs/toolkit';

export const SET_ORDERS_FILTER = 'orders/setOrdersFilter';

export const setOrdersFilter = createAction(SET_ORDERS_FILTER, text => ({
    payload: text,
}));
